import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {FormControl, FormGroup, Validators, FormBuilder} from '@angular/forms';
import {Subscription} from 'rxjs';
import {AuthService} from 'src/app/services/auth.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    public form: FormGroup;
    country_code: any = localStorage.getItem('country_code');
    public active = 1;
    loading: boolean;
    errors: boolean;

    constructor(private _authService: AuthService,
                private router: Router, private formBuilder: FormBuilder) {

    }

    owlcarousel = [
        {
            title: 'Welcome to Multikart',
            desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy.',
        },
        {
            title: 'Welcome to Multikart',
            desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy.',
        },
        {
            title: 'Welcome to Multikart',
            desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy.',
        }
    ];
    owlcarouselOptions = {
        loop: true,
        items: 1,
        dots: true
    };


    ngOnInit() {
        this.form = this.formBuilder.group({
            email: ['', [Validators.required]],
            password: ['', [Validators.required]],

        });
    }

    loginUser() {
        var params: any = {};
        params.email = this.form.get('email').value;
        params.password = this.form.get('password').value;
        this._authService.loginUser(params).subscribe((res: any) => {
            // Store the access token in the localstorage
            console.log(res);
            console.log(res.data.user.roles);
            if (res.data.user.roles === 1) {
                localStorage.setItem('role', res.data.user.roles);
            }
            localStorage.setItem('token', res.data.token);
            //  localStorage.setItem('county_code',res.data.country_code);
            console.log(localStorage.getItem('token'));
            // this.loading = false;
            //console.log(this.loginUser);
            //let country_code=localStorage.getItem('country_code');
            // Navigate to home page
            this.router.navigate(['/dashboard/default']);
        }, (err: any) => {

            // This error can be internal or invalid credentials
            // You need to customize this based on the error.status c
            alert('invalid credentials');
        });

    }

    onSubmit() {

    }

}
